import React, { useEffect, useState } from "react";
import axios from "axios";
import classNames from "classnames";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useLocation } from "react-router";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import PersonIcon from "@material-ui/icons/Person";
import BusinessIcon from "@material-ui/icons/Business";
import CallIcon from "@material-ui/icons/Call";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Card from "components/Card/Card.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import SweetAlert from "react-bootstrap-sweetalert";

import { headApi, credentials, convertToNextTenth } from "utils/headApi";

import navbarsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/navbarsStyle.js";
import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";

const useStyles = makeStyles(navbarsStyle);
const useStyle = makeStyles(productStyle);
const useStyleAlert = makeStyles(style);

export default function ProductList() {
  // ---------------- States ----------------
  const [mobile, setMobile] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [userDel, setUserDel] = useState({});
  const [userAddress, setUserAddress] = useState({});
  const [prodList, setProdList] = useState([]);
  const [comment, setComment] = useState(
    "Mix different four sizes in one design, or mix different six designs in one size, or one design in one size."
  );
  const [commentErr, setCommentErr] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [submitteds, setSubmitteds] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");

  const [loading, setLoading] = useState(true);

  const classes = useStyles();
  const classe = useStyle();
  const classeAlert = useStyleAlert();

  const { search } = useLocation();
  const a = new URLSearchParams(search).get("a");
  const p = new URLSearchParams(search).get("p");
  const category = new URLSearchParams(search).get("category");
  const state = new URLSearchParams(search).get("state");
  const catSize = new URLSearchParams(search).get("catSize");
  const country = new URLSearchParams(search).get("country");

  const clientObj = JSON.parse(sessionStorage.getItem("sessionData"));

  // ---------------- Fetch Products ----------------
  useEffect(() => {
    const getProd = async () => {
      try {
        const results = await fetch(`${headApi}/product/findByStateAndCategoryAndParent/${state}/${category}/${catSize}`, {
          method: "GET",
          headers: { Authorization: `Basic ${credentials}` },
        });
        const res = await results.json();
        if (res.products && Array.isArray(res.products)) {
          setProdList(res.products.filter((f) => f.id != p && f.active === true));
        } else {
          setProdList([]);
        }
      } catch (err) {
        console.error("Error fetching products:", err);
        setProdList([]);
      } finally {
        setLoading(false);
      }
    };
    getProd();
  }, [state, category, catSize, p]);

  // ---------------- Fetch User Details ----------------
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userRes = await axios.get(`${headApi}/admin/byId/${a}`, {
          headers: { Authorization: `Basic ${credentials}` },
        });
        setUserDel(userRes.data);

        const addressRes = await axios.get(`${headApi}/adminAddress/allList`, {
          headers: { Authorization: `Basic ${credentials}` },
        });
        const address = addressRes.data.AdminAddressList.find(
          (item) => item.adminId == a
        );
        setUserAddress(address || {});
      } catch (err) {
        console.error("Error fetching user details:", err);
      }
    };
    fetchUserData();
  }, [a]);

  // ---------------- Enquiry Handlers ----------------
  const handleRequriment = async () => {
    let errorCount = 0;
    if (!mobile) {
      errorCount++;
      setMobileErr("Please Enter Number");
    }
    if (!email) {
      errorCount++;
      setEmailErr("Please Enter Email");
    }
    if (!comment) {
      errorCount++;
      setCommentErr("Please Enter Comment");
    }
    if (errorCount === 0) {
      const from = `noreply@${userDel.websitename}`;
      const subject = `Welcome to ${userDel.company}! ( ${email})`;
      const message = `${comment} (Mobile no. ${mobile})`;

      try {
        const res = await fetch(
          `${headApi}/email/sendEnquiry/${subject}/${message}/${email}/${from}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Basic ${credentials}`,
            },
            body: JSON.stringify({}),
          }
        );
        const data = await res.json();
        if (data.message === "Data Inserted Successfully !!!") {
          setAlertType("success");
          setAlertMsg("Successfully Sent!");
          setSubmitted(true);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleEmail = async () => {
    if (!clientObj) {
      setAlertType("danger");
      setAlertMsg("Go to Login");
      setSubmitteds(true);
      return;
    }

    const from = `noreply@${userDel.websitename}`;
    const subject = `Welcome to ${userDel.company}! ( ${clientObj.email})`;
    const message = `Mobile no. ${clientObj.mobile}`;

    try {
      const res = await fetch(
        `${headApi}/email/sendEnquiry/${subject}/${message}/${clientObj.email}/${from}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({}),
        }
      );
      const data = await res.json();
      if (data.message === "Data Inserted Successfully !!!") {
        setAlertType("success");
        setAlertMsg("Successfully Sent!");
        setSubmitted(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    setSubmitteds(false);
    window.location.reload(false);
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className={classes.container + " cd-section"} id="productList">
      <GridContainer>
        {/* ---------- Related Products ---------- */}
        <GridItem md={12} sm={12}>
          <div className={classes.relatedProducts}>
            <h3 className={classNames(classes.title, classes.textCenter)}>
              You may also be interested in:
            </h3>

            {submitted && (
              <SweetAlert
                type={alertType}
                style={{ display: "block", marginTop: "100px" }}
                title={alertMsg}
                onConfirm={hideAlert}
                confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
              >
                Added to the Enquiry!!
              </SweetAlert>
            )}
            {submitteds && (
              <SweetAlert
                type={alertType}
                style={{ display: "block", marginTop: "100px" }}
                title={alertMsg}
                onConfirm={hideAlert}
                confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
              />
            )}

            <GridContainer>
              {prodList.map((prod) => (
                <GridItem sm={6} md={3} key={prod.id}>
                  <Card product>
                    <CardHeader image>
                      <a
                        href={`/list?a=${prod.adminId}&p=${prod.id}&category=${category}&catSize=${catSize}&country=${country}&state=${state}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={prod.image} alt={prod.company} />
                      </a>
                    </CardHeader>
                    <CardBody>
                      <h6 className={classNames(classe.cardCategory, classe.textRose)}>
                        {prod.category} - {prod.parent}
                      </h6>
                      <h5 className={classe.cardTitle} style={{ marginTop: "-15px" }}>
                        <a
                          href={`/list?a=${prod.adminId}&p=${prod.id}&category=${category}&catSize=${catSize}&country=${country}&state=${state}&l=#aboutCompany`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {prod.company}
                        </a>
                      </h5>
                      <h6 className={classe.cardDescriptionl} style={{ marginTop: "-15px" }}>
                        {prod.city} {prod.state} {prod.country}
                      </h6>
                      <h5 className={classe.cardDescriptionl}>
                        <span style={{ color: prod.gstCash ? "red" : "black" }}>
                          Price ₹{" "}
                          {prod.gstCash ? convertToNextTenth(prod.taxInclude / prod.box) : convertToNextTenth(prod.cashPrice / prod.box)}
                        </span>
                      </h5>
                      <h6 className={classe.cardDescriptionl}>
                        <Tooltip title="Click Here to Call" placement="top">
                          <Button
                            color="info"
                            round
                            href={`/list?a=${prod.adminId}&p=${prod.id}&category=${category}&catSize=${catSize}&country=${country}&state=${state}&l=#contactAreas`}
                            target="_blank"
                          >
                            Contact
                          </Button>
                        </Tooltip>
                      </h6>
                    </CardBody>
                  </Card>
                </GridItem>
              ))}
            </GridContainer>
          </div>
          <hr />
        </GridItem>

        {/* ---------- Enquiry & Contact ---------- */}
        <GridItem md={12}>
          <GridContainer>
            <GridItem md={7} sm={7}>
              <div className={classes.relatedProducts}>
                <h5 style={{ textAlign: "center", textDecoration: "underline" }}>
                  Send Enquiry for {userDel.company}
                </h5>
                <GridContainer>
                  <GridItem md={2} sm={2} xs={4}>
                    <img
                      src="https://api.inshabangles.com/api/admin/logoImageDownload/insha-bangles-bill-logo.png?id=2"
                      style={{ width: 100, height: 100 }}
                    />
                  </GridItem>
                  <GridItem md={10} sm={10} xs={8}>
                    <p>Contact Seller and get details on your mobile quickly</p>
                    <label>Mobile Number</label>
                    <GridContainer>
                      <GridItem md={6}>
                        <PhoneInput
                          inputStyle={{
                            width: "100%",
                            border: "none",
                            borderBottom: "1px solid #040000",
                            borderRadius: 0,
                          }}
                          country="in"
                          value={mobile}
                          onChange={(m) => {
                            setMobile(m.length <= 12 ? m : mobile);
                            setMobileErr("");
                          }}
                        />
                        <span style={{ color: "red" }}>{mobileErr}</span>
                      </GridItem>
                      <GridItem md={6}>
                        <CustomInput
                          labelText="Email"
                          id="email"
                          formControlProps={{ fullWidth: true }}
                          inputProps={{
                            value: email,
                            onChange: (e) => {
                              setEmail(e.target.value);
                              setEmailErr("");
                            },
                            placeholder: "Enter Email here",
                            type: "text",
                            autoComplete: "off",
                          }}
                          required
                        />
                        <span style={{ color: "red" }}>{emailErr}</span>
                      </GridItem>
                    </GridContainer>
                    <CustomInput
                      labelText="Comment"
                      id="comment"
                      inputProps={{
                        placeholder:
                          "Mix different four sizes in one design, or mix different six designs in one size.",
                        value: comment,
                        multiline: true,
                        rows: 2,
                        onChange: (e) => {
                          setComment(e.target.value);
                          setCommentErr("");
                        },
                      }}
                      formControlProps={{ fullWidth: true }}
                    />
                    <span style={{ color: "red" }}>{commentErr}</span>
                    <br />
                    <Button color="info" onClick={handleRequriment}>
                      Submit Requirement
                    </Button>
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>

            <GridItem md={5} sm={5}>
              <div className={classes.relatedProducts}>
                <h5 style={{ textAlign: "center", textDecoration: "underline" }}>
                  Seller Contact Details
                </h5>
                <GridContainer style={{ marginLeft: "50px" }}>
                  <GridItem md={12}>
                    <p>
                      {userAddress?.company ||
                        `${userAddress?.firstName || ""} ${userAddress?.lastName || ""}`}
                    </p>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <PersonIcon />
                      <p style={{ marginLeft: "10px" }}>
                        {userAddress?.firstName} {userAddress?.lastName}
                      </p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <BusinessIcon />
                      <p style={{ marginLeft: "10px", fontSize: "12px" }}>
                        {userAddress?.plotHouseNo} {userAddress?.areaColony}
                        <br />
                        {userAddress?.landMark} {userAddress?.road} - {userAddress?.zipCode}
                        <br />
                        {userAddress?.city}, {userAddress?.state}, {userAddress?.country}
                      </p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <CallIcon />
                      <p style={{ marginLeft: "10px" }}>{userAddress?.mobile}</p>
                    </div>
                  </GridItem>
                  <Button color="info">Send SMS</Button>
                  <Button color="info" style={{ marginLeft: "10px" }} onClick={handleEmail}>
                    Send Email
                  </Button>
                </GridContainer>
              </div>
            </GridItem>
          </GridContainer>
          <hr />
        </GridItem>
      </GridContainer>
    </div>
  );
}
